import Cookies from "universal-cookie";

const cookies = new Cookies();

// Mesma API principal do card "Origem do custo" (SERVER_URL) — o drill-down é uma
// extensão do card, não do back office. Autenticado por Bearer, escopo por ownership
// no BE. Retorna null em falha (o offcanvas mostra estado de erro).
const BASE = process.env.SERVER_URL || "";
const enc = encodeURIComponent;
const UNCERTAIN_WRITEBACK_CODES = new Set([
  "writeback_in_progress",
  "writeback_reconciliation_required",
]);
const safeText = (value, fallback) => (
  typeof value === "string" && value.trim() ? value : fallback
);

export const isUncertainWritebackResult = (result) => (
  result?.httpStatus === 0
  || result?.httpStatus >= 500
  || UNCERTAIN_WRITEBACK_CODES.has(result?.code)
);

export const fetchCostOriginTitles = async (
  projectId,
  { bucket, origin, page = 0, pageSize = 50, search } = {}
) => {
  if (!projectId) return null;
  const { token } = cookies.get("userId") || {};
  const params = new URLSearchParams();
  if (bucket) params.set("bucket", bucket);
  if (origin) params.set("origin", origin);
  if (search) params.set("search", search);
  params.set("page", String(page));
  params.set("pageSize", String(pageSize));
  try {
    const res = await fetch(
      `${BASE}/project/${enc(projectId)}/costOriginTitles?${params.toString()}`,
      { headers: { Authorization: `Bearer ${token}` } }
    );
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

// Editor de apropriação (Fase 3 — write-back Sienge). As 3 funções abaixo seguem o
// mesmo estilo acima (Bearer via cookie, base SERVER_URL) mas preservam o corpo da
// resposta mesmo em erro (403 WRITEBACK_DISABLED / mensagens de falha do BE), pois o
// editor precisa exibi-las — diferente do drill-down read-only, que só usa null/dado.

export const fetchBillAppropriation = async (projectId, billId, { signal } = {}) => {
  if (!projectId || !billId) return null;
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(
      `${BASE}/project/${enc(projectId)}/billAppropriation?billId=${enc(billId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        ...(signal ? { signal } : {}),
      }
    );
    const data = await res.json().catch(() => null);
    if (!res.ok) return { httpStatus: res.status, ...(data || {}) };
    return data;
  } catch {
    return null;
  }
};

export const fetchEapSheetItems = async (projectId, buildingUnitId, { signal } = {}) => {
  if (!projectId || !buildingUnitId) return null;
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(
      `${BASE}/project/${enc(projectId)}/eapSheetItems?buildingUnitId=${enc(buildingUnitId)}`,
      {
        headers: { Authorization: `Bearer ${token}` },
        ...(signal ? { signal } : {}),
      }
    );
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
};

export const updateBillAppropriation = async (
  payload,
  { idempotencyKey, signal } = {},
) => {
  const { token } = cookies.get("userId") || {};
  try {
    const res = await fetch(`${BASE}/project/updateBillAppropriation`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
        ...(idempotencyKey ? { "X-Idempotency-Key": idempotencyKey } : {}),
      },
      body: JSON.stringify(payload),
      ...(signal ? { signal } : {}),
    });
    const data = await res.json().catch(() => null);
    if (!res.ok) {
      const result = {
        ok: false,
        httpStatus: res.status,
        code: typeof data?.code === "string" ? data.code : "request_failed",
        message: safeText(data?.message, "Erro ao salvar a apropriação. Tente novamente."),
      };
      return { ...result, retryable: isUncertainWritebackResult(result) };
    }
    return {
      ok: true,
      httpStatus: res.status,
      code: data?.code ?? res.status,
      message: safeText(data?.message, undefined),
    };
  } catch {
    return {
      ok: false,
      httpStatus: 0,
      code: "network_error",
      message: "Erro de conexão. Tente novamente.",
      retryable: true,
    };
  }
};
